/* eslint-disable */

import Swiper from 'swiper/dist/js/swiper.min.js'

export default {
  name: 'swiper-dates',

  componentDidMount() {
    let baseURL = window.location.href.split('/')
    let currentDate = baseURL.splice(-3, 3).join('/')
    baseURL = baseURL.join('/')

    const slides = this.el.querySelectorAll('.swiper-slide')
    let defaultSlide = slides.length - 1
    for (let i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-date') === currentDate) {
        defaultSlide = i
      }
    }

    let timer = 0

    const that = this
    let firstRender = true

    setTimeout(() => {
      this.swiper = new Swiper(this.el.querySelector('.swiper-container'), {
        // Optional parameters
        direction: 'horizontal',
        speed: 600,
        // initialSlide: self.el.querySelectorAll('.swiper-slide').length - 3, // 3 car slide-duplicate-...
        // reverseDirection: true,
        loop: false,
        centeredSlides: true,
        initialSlide: defaultSlide,
        // centerInsufficientSlides: true,
        // loopedSlides: 5,
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-dates-button-next',
          prevEl: '.swiper-dates-button-prev',
        },
        slidesPerView: 1,
        spaceBetween: 0,

        // slidesOffsetBefore: 0,

        /*  autoplay: {
          delay: 1000,
          disableOnInteraction: true,
        }, */

        on: {
          slideChangeTransitionEnd: function(s) {
            if (firstRender) {
              firstRender = false
            } else {
              timer = setTimeout(() => {
                window.location.href = `${baseURL}/${slides[
                  that.swiper.activeIndex
                ].getAttribute('data-date')}`
              }, 1000)
            }
          },
          slideChangeTransitionStart: function() {
            clearTimeout(timer)
          },
        },
        // breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 768px
          769: {
            slidesPerView: 3,
            slidesOffsetBefore: 50,
            slidesOffsetAfter: 50,
            // spaceBetween: 180,
          },
        },
      })
    }, 300)
  },
}
